/**
 * D11: Teacher Assessment Assignments
 * Source: Teacher portal — "Toets klaarzetten" feature
 */

import { USE_BACKEND, readJson, writeJson } from '../helpers';
import type { TeacherAssignment } from '../../assessment';
const TEACHER_ASSIGNMENTS_KEY = 'teacher_assignments';

/** Get all teacher-created assessment assignments */
export async function getTeacherAssignments(): Promise<Record<string, TeacherAssignment>> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  return readJson<Record<string, TeacherAssignment>>(TEACHER_ASSIGNMENTS_KEY, {});
}

/** Save or update a teacher assessment assignment */
export async function saveTeacherAssignment(id: string, assignment: TeacherAssignment): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, TeacherAssignment>>(TEACHER_ASSIGNMENTS_KEY, {});
  all[id] = assignment;
  writeJson(TEACHER_ASSIGNMENTS_KEY, all);
}

/** Delete a teacher assessment assignment */
export async function deleteTeacherAssignment(id: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, TeacherAssignment>>(TEACHER_ASSIGNMENTS_KEY, {});
  delete all[id];
  writeJson(TEACHER_ASSIGNMENTS_KEY, all);
}

/** Archive a teacher assessment assignment */
export async function archiveTeacherAssignment(id: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, TeacherAssignment>>(TEACHER_ASSIGNMENTS_KEY, {});
  const assignment = all[id];
  if (!assignment) return;
  assignment.status = 'archived';
  all[id] = assignment;
  writeJson(TEACHER_ASSIGNMENTS_KEY, all);
}

/** Mark an assignment as completed by a specific student */
export async function markAssignmentCompletedByStudent(assignmentId: string, studentId: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, Record<string, unknown>>>(TEACHER_ASSIGNMENTS_KEY, {});
  const assignment = all[assignmentId];
  if (!assignment) return;
  const completedBy = assignment.completedByStudentIds as string[] || [];
  if (!completedBy.includes(studentId)) {
    assignment.completedByStudentIds = [...completedBy, studentId];
    writeJson(TEACHER_ASSIGNMENTS_KEY, all);
  }
}